exports.appVersion = "0.5.6"
exports.appName = "iProposeYou"
